export default __webpack_public_path__ + "static/media/drawer-do-and-dont-2.662204c9.png";